// eslint-disable-next-line import/prefer-default-export
export const PAGE_TITLE: string = 'MOOVYMED v0.1';
export const DEFAULT_GRADIENT: string = 'linear-gradient(45deg, rgba(196,27,104,1) 0%, rgba(100,189,254,1) 50%, rgba(255,255,255,1) 100%)';
export const DEFAULT_GRADIENT_NO_WHITE: string = 'linear-gradient(45deg, rgba(196,27,104,1) 0%, rgba(100,189,254,1) 100%)';
export const DEFAULT_BORDER_RADIUS: number = 20;
export const PAPER_BG_COLOR: string = 'rgba(255,255,255, 0.75)';
export const DEFAULT_CONTAINER_WIDTH: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false = 'lg';
export const DEFAULT_GRID_SPACING: 2 | 4 = 2;
